export default "__VITE_ASSET__8f6139fc__"